import { MtObjectWork, MtWork } from './MtWork';

export class ResultWorkGeneration {
  generatedWorks: MtWork[];
  excludedObjects: MtObjectWork[];
}

export class MaintenanceOrder {
  Id?: string;
  designation?: string;
  date?: Date;
  state?: string;
  number?: string;
  remark?: string;
}
